/** Navigation URLs for views are distinct from the stable controlled-RPC fence keys.
 * Shell admission and discovery use the existing view fence; the resolver revision is unchanged.
 */
export const HR_PAGE_PATHS = {
  '/people/recruitment': '/people/workers?view=recruitment',
  '/people/development/supervision': '/people/development/supervision',
  '/people/development/casual-conversion': '/people/development/casual-conversion',
  '/me/casual-conversion': '/me/casual-conversion',
  '/people/evidence': '/people/evidence',
  '/people/development/flexible-work': '/people/development?view=flexible-work',
  '/me/availability': '/me/availability',
  '/people/policies-conduct/cases': '/people/policies-conduct/cases',
  '/me/policies': '/me/policies',
  '/me/work-readiness': '/me/work-readiness',
} as const;

export function hrPageFenceKey(href: string): string {
  const [pathname = '', query = ''] = href.split('?');
  const view = new URLSearchParams(query.split('#')[0]).get('view');
  if (pathname === '/people/workers' && view === 'recruitment') return '/people/recruitment';
  if (pathname === '/people/development' && view === 'flexible-work')
    return '/people/development/flexible-work';
  return pathname.split('#')[0]!;
}
